<template>
  <div>
    <div
      v-for="(product, index) of definedItems" 
      :key="'product_' + index"
    >
      <div class="pseudo-selector"
        :class="{
          'pseudo-selector--with-flex': product.directChildrenObjs && product.directChildrenObjs.length,
          'pseudo-selector--active': internalSelectionState[product.id] && internalSelectionState[product.id] === 'Selected',
          'pseudo-selector--fuzzy': internalSelectionState[product.id] && internalSelectionState[product.id] === 'Fuzzy'
        }"
        :style="getPseudoSelectorStyling()"
        @click="selectInChild(product)"
      >
        <div class="select-item__left" :title="product.display">
          <div class="pseudo-selector__checkbox" :style="getPseudoCheckboxStyling()"></div>
          {{ product.displayHierarchy || product.display || product.id }}
        </div>
        <div class="select-item__right" 
          v-if="product.directChildrenObjs && product.directChildrenObjs.length"
          @click.stop.prevent="expandedMap[product.id] = !expandedMap[product.id]"
        >
          <i class="material-icons" v-if="!expandedMap[product.id]">expand_more</i>
          <i class="material-icons" v-if="expandedMap[product.id]">expand_less</i>
        </div>
      </div>
      <div class="collapsible-container" v-if="product.directChildrenObjs && product.directChildrenObjs.length"
        :class="{'collapsible-container--expanded': expandedMap[product.id]}"
      >
        <ProductTreeLevel 
          :level="product.level + 1"
          :items="product.directChildrenObjs"
          :internalSelectionState="internalSelectionState"
          :filter="filter"
          @select="selectInChild($event)" 
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class ProductTreeLevel extends Vue {
  @Prop({ default: () => [] })
  public items: any[];

  @Prop({ default: () => ({}) })
  public internalSelectionState: any;

  @Prop({ default: 1 })
  public level: number;

  @Prop({ default: '' })
  public filter: string;

  public expandedMap: any = {};

  get definedItems() {
    return this.items.filter((item: any) => !!item);
  }

  public getPseudoSelectorStyling() {
    return {
      'padding-left': 10 + (this.level * 30) + 'px'
    }
  }

  public getPseudoCheckboxStyling() {
    return {
      'left': 10 + ((this.level - 1) * 30) + 'px'
    }
  }

  public selectInChild(product: any) {
    this.$emit('select', product);
  }

  @Watch('filter')
  public onPropertyChanged(value: string, oldValue: string) {
    this.createMap();
  }

  public createMap() {
    const obj: any = {};
    this.definedItems.forEach((item) => {
      if (this.filter && this.filter.length) {
        const filter = this.filter.toLowerCase();
        if (item.display && item.display.toLowerCase().indexOf(filter) === -1) {
          // We have a filter, this item is showing, but it does not itself match the filter.
          // We can therefore conclude one of its descendents does, so expand
          obj[item.id] = true;
          return;
        }
      }

      obj[item.id] = false;
    });
    this.expandedMap = {...obj};
  }

  public mounted() {
    // TODO: do this when items array changes too.. maybe?
    this.createMap();
  }
}

</script>

<style scoped lang="scss">
  .select-item__right {
    padding-right: 30px;
  }

 .collapsible-container {
   max-height: 0;
   overflow: hidden;
   transition: max-height ease-out 300ms;

   &--expanded {
     max-height: 5000px;
     transition: max-height ease-in 300ms;
   }
 }
</style>